import { useEffect, useState } from "react";

export const useImagePreload = (imageUrl: string | undefined, imageSrcSet?: string): boolean => {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        if (!imageUrl) {
            setIsLoaded(false);
            return undefined;
        }

        const img = new Image();

        img.onload = () => {
            setIsLoaded(true);
        };

        img.onerror = () => {
            setIsLoaded(false);
        };

        if (imageSrcSet) {
            img.srcset = imageSrcSet;
        }

        img.src = imageUrl;

        return () => {
            img.onload = null;
            img.onerror = null;
        };
    }, [imageUrl, imageSrcSet]);

    return isLoaded;
};
